var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('md-progress-spinner',{attrs:{"md-stroke":2,"md-diameter":30,"md-mode":"indeterminate"}}),_c('span',{staticStyle:{"margin-left":"20px"}},[_vm._v("Loading...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }